<app-header [forceLightBackground]="true"></app-header>
<div class="profile-page">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="profile-page--sidebar-col">
      <app-consumer-sidebar></app-consumer-sidebar>
    </div>
    <div class="profile-page--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <div class="profile-container">
        <app-profile></app-profile>
      </div>
    </div>
  </div>
</div>
